import DropDownCard from "./DropDownCard";
import FormOption, { IOption } from "./FormOption";

export interface IAutoComplete {
  placeholder: string;
  filteredOptions: IOption[];
  activeOptionIndex: number;
  onClickOption: any;
}

export default function AutoComplete(props: IAutoComplete) {
  return props.filteredOptions.length ? (
    <DropDownCard>
      {props.filteredOptions.map((option: IOption, index: number) => {
        let className;
        if (index === props.activeOptionIndex) {
          className = "suggestion-active";
        }
        return (
          <div
            className={className}
            key={option.label}
            onClick={props.onClickOption}
          >
            <FormOption
              label={option.label}
              value={option.label}
              handleLabel={option.handleLabel}
              handleValue={option.handleValue}
            />
          </div>
        );
      })}
    </DropDownCard>
  ) : (
    <DropDownCard>
      <FormOption label="We couldn't find anything" value={null} />
    </DropDownCard>
  );
}
